<script>
  import { onMount } from "svelte";
  import { Input, Switch, Badge } from "spaper";
  import { upload } from "svelte-awesome/icons";
  import { strings } from "../constants/strings";
  import { navigate } from "svelte-routing";
  import { loadAdoptableInfo, updateAdoptableInfo, showErrorThenCallback } from "../utils/utils";
  import Icon from "svelte-awesome";
  import HeaderMini from "../components/HeaderMini.svelte";
  import Footer from "../components/Footer.svelte";


  export let id;
  export let kind;

  // Form data
  let description = "";
  let sterilized = false;
  let published = false;
  let likesChildren = false;
  let likesOtherPets = false;

  let adoptableInfo = {};
  let imgSrc = "";
  let imgStatus = 2;
  let formError = "";
  let formStatus = 0;
  let pictureChanged = false;
  $: imgText = strings.formMessages.imageLifecycle[imgStatus];

  const getAdoptableInfo = async () => {
    try {
      adoptableInfo = await loadAdoptableInfo(id, kind);
      description = adoptableInfo.description;
      sterilized = adoptableInfo.sterilized;
      published = adoptableInfo.published;
      likesChildren = adoptableInfo.likeschildren;
      likesOtherPets = adoptableInfo.likesotherpets;
      imgSrc = `${adoptableInfo.image}?x=${new Date()}`;
    } catch(error) {
      showErrorThenCallback(error, () => { navigate("/_admin") } );
    }
  };

  const resetForm = () => {
    description = adoptableInfo.description;
    sterilized = adoptableInfo.sterilized;
    published = adoptableInfo.published;
    imgSrc = adoptableInfo.image;
    imgStatus = 2;
    imgText = strings.formMessages.imageLifecycle[imgStatus];
    formStatus = 0; // Stand-by
    formError = "";
  };

  const updateImage = () => {
    const input = document.querySelector("#adoptable-pic-input");
    let reader = new FileReader();
    reader.onload = (i) => {
      imgSrc = i.target.result;
      imgStatus = 2;
      pictureChanged = true;
    };
    reader.readAsDataURL(input.files[0]);
    imgStatus = 1;
  };

  const validateForm = () => {
    if (description == "") {
      formError = strings.formMessages.validation.allFieldsRequired;
      return false;
    }
    formError = "";
    return true;
  };

  const getFormData = () => {
    let formData = new FormData();
    const input = document.querySelector("#adoptable-pic-input");
    formData.append("_id", id);
    formData.append('kind', kind);
    formData.append('description', description);
    formData.append('sterilized', sterilized);
    formData.append('likesChildren', likesChildren);
    formData.append('likesOtherPets', likesOtherPets);
    formData.append('published', published);
    if (pictureChanged) {
      formData.append('picture', input.files[0]);
    }
    return formData;
  };

  const submitForm = async () => {
    if (!validateForm()) return;
    formStatus = 1; // Submitting
    const data = getFormData();
    try {
      const res = await updateAdoptableInfo(data);
      formStatus = 2; // Submited
      setTimeout(() => {
        navigate(`/adoptable/${kind}/${id}`);
      }, 2500);
    } catch (errorMessage) {
      resetForm();
      formError = errorMessage;
    }
  };

  onMount(getAdoptableInfo);
</script>

<HeaderMini />
<div class="form-group">
  <img src={imgSrc} alt="Adoptable" width="180" />
  <br />
  <br />
  <input
    type="file"
    id="adoptable-pic-input"
    name="picture"
    class="pic-picker"
    on:change={updateImage}
  />
  <label for="adoptable-pic-input" class="paper-btn">
    <Icon data={upload} />
    &nbsp;&nbsp;{imgText}
  </label>
  <br />
  <br />
  <Switch bind:checked={sterilized}
    >Esterilizado: {sterilized ? "Sí" : "No"}</Switch
  >
  <br />
  <br />
  <Switch bind:checked={likesChildren}
    >Convive con niños: {likesChildren ? "Sí" : "No"}</Switch
  >
  <br />
  <br />
  <Switch bind:checked={likesOtherPets}
    >Convive con otras mascotas: {likesOtherPets ? "Sí" : "No"}</Switch
  >
  <br />
  <br />
  <Switch bind:checked={published}
    >Publicado: {published ? "Sí" : "No"}</Switch
  >
  <br />
  <p>Descripción</p>
  <Input type="textarea" bind:value={description} />
  <br />
  {#if formError != ""}
    <Badge type="danger">{formError}</Badge>
    <br />
    <br />
  {/if}
  {#if formStatus == 0}
    <button class="btn-secondary" on:click={submitForm}>Guardar</button>
  {:else if formStatus == 1}
    <Badge type="secondary">Guardando...</Badge>
  {:else if formStatus == 2}
    <Badge type="success">¡Guardado!</Badge>
  {/if}
</div>
<Footer />

<style>
  .form-group {
    margin-left: 10%;
  }
  .pic-picker {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
</style>
